import { cloneDeep } from "lodash";

import { mergeControlProps, unmergeControlProps } from "../../../shared/utils";

export const doControlOptionSort = (props) => {
  const newProps = cloneDeep(props);
  const mergedPropsArray = mergeControlProps(newProps);

  if (newProps.sort_options) {
    // sort A - Z by the option property
    // break sort at the point where blanks exist within the list
    
    const isBlank = (txt) => {
      // Check if txt is null or undefined
      if (txt === null || typeof txt === 'undefined') {
        return true; // Return true if txt is null or undefined
      }
      
      // Check if txt is blank
      return /^\s*$/.test(txt);
    };
    
    const lc = (v) => !isBlank(v.option) && v.option.toLowerCase();
    mergedPropsArray.sort((a, b) => (lc(a) > lc(b) ? 1 : lc(b) > lc(a) ? -1 : 0));
  } else {
    // What do we do when they uncheck the sort option
    // Do we randomnise?
    // mergedPropsArray.sort(() => Math.random() - 0.5); // sort randomly
  }

  const sortedProps = unmergeControlProps(mergedPropsArray, newProps);

  if (sortedProps.error) return { error: true };

  const { options, weights, images } = sortedProps;

  newProps.options = options || [];
  if (newProps.weights && weights) newProps.weights = weights;
  if (newProps.images && images) newProps.images = images;

  return newProps;
};

export const resolveControlWeights = (oldWeights, currentOptions) => {
  let newWeights = oldWeights.slice(0, currentOptions.length);
  if (newWeights.length < currentOptions.length) {
    newWeights = newWeights.concat(Array(currentOptions.length - newWeights.length).fill(1));
  }

  return newWeights;
};